import React, { useEffect, useMemo, useState } from "react";
import { ImportDonaturForm } from "./ImportDonaturForm";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../_redux/donatur/donaturAction";
import { toast } from "react-toastify";
import { readSpreadsheet, toastOption } from "../../../../_metronic/_helpers";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardHeaderToolbar
} from "../../../../_metronic/_partials/controls";
import * as XLSX from "xlsx";
import * as ExcelJS from "exceljs";
import moment from "moment";
import ImportDonaturTable from "./ImportDonaturTable";
import LoadingAnimation from "../loading-animation/LoadingAnimation";
import { saveAs } from "file-saver";
import { v4 as uuidv4 } from "uuid";
import { DONOR_IMPORT_FIELDS } from "../../../config/helper";
import DonorInvalidTable from "./DonorInvalidTable";
import { ActionButton } from "../../../../_metronic/_partials/controls/ActionButton";
import ModalEditDonor from "./ModalEditDonor";
import Loading from "../../../../_metronic/layout/components/loading/Loading";

const initialDonorData = {
  type: null,
  name: "",
  greeting: "",
  hp: "",
  email: "",
  address: null,
  district: null,
  city: null,
  province: null,
  postal_code: null,
  nik: null,
  npwp: null,
  is_alive: true,
  is_active: true,
  kode_rekening: null
};

export const ImportDonaturDialog = ({ id, history }) => {
  // ImportDonatur Redux state
  const dispatch = useDispatch();
  const { actionsLoading, donaturForEdit, error, isLetter } = useSelector(
    state => ({
      actionsLoading: state.donaturs.actionsLoading,
      donaturForEdit: state.donaturs.donaturForEdit,
      isLetter: state.donaturs.is_letter,
      error: state.donaturs.error
    }),
    shallowEqual
  );

  if (error) {
    toast.error(error, toastOption);
  }

  const [donorRows, setDonorRows] = useState([]);
  const [errorRows, setErrorRows] = useState([]);
  const [isValidation, setIsValidation] = useState(true);

  const [loading, setLoading] = useState({
    show: false,
    percentage: 0
  });

  const [openEditDonor, setOpenEditDonor] = useState({
    show: false,
    initValues: {}
  });

  const [spreadSheet, setSpreadSheet] = useState(null);

  function backToList() {
    history.push(`/donatur`);
  }
  useEffect(() => {
    if (spreadSheet) {
      parseDonorRows(spreadSheet);
    }
  }, [spreadSheet]);

  async function parseDonorRows() {
    const result = await readSpreadsheet(spreadSheet);

    if (!(result instanceof Array)) {
      return [];
    }

    const rows = result.map(row => {
      const item = {
        uuid: uuidv4(),
        type: null,
        name: "",
        greeting: "",
        hp: "",
        email: "",
        address: null,
        district: null,
        city: null,
        province: null,
        postal_code: null,
        nik: null,
        npwp: null,
        is_alive: "Hidup",
        is_active: "Aktif",
        kode_rekening: null
      };

      Object.entries(DONOR_IMPORT_FIELDS).forEach(([label, field]) => {
        item[field] = row[label] ?? item[field];
        // ? Format date
        if (label === "Tanggal Lahir *") {
          const trxDate = moment(
            Math.floor(row[label] - 25569) * 86400 * 1000
          ).format("YYYY-MM-DD");

          item[field] = trxDate;
        }
        // ? Format HP to string
        if (label === "HP" && row[label]) {
          item[field] = row[label].toString();
        }
      });
      return item;
    });

    setDonorRows(rows);
    validateData(rows);
  }

  // * Validation Data
  const validateData = async importData => {
    setLoading(prev => ({
      ...prev,
      show: true,
      percentage: 0
    }));
    const tempData = [...importData];
    const percentage = (tempData.length * 100) / tempData.length;

    let currentPercentage = 0;
    const successProcessData = [];

    const hasErrorData = [];

    for (const item of importData) {
      if (item.hp && item.hp.substring(0, 1) == "8") {
        item.hp = `0${item.hp}`;
      }

      if (item.province) item.province = item.province.toUpperCase();
      if (item.city) item.city = item.city.toUpperCase();
      if (item.district) item.district = item.district.toUpperCase();

      await dispatch(actions.validationImportDonatur(item)).then(response => {
        if (response.error.length !== 0) {
          hasErrorData.push(response);
          setDonorRows(prev => {
            const temp = [...prev];
            const filteredNotError = temp.filter(
              oldData => oldData.uuid !== response.data.uuid
            );
            return filteredNotError;
          });
          // ? Set Error / Invalid Data
          setErrorRows(prev => {
            const temp = [...prev];
            temp.push(response);
            return temp;
          });
        }
        // ? Loading State
        successProcessData.push(response);
        currentPercentage = Math.floor(
          (successProcessData.length * 100) / tempData.length
        );
        setLoading(prev => ({
          ...prev,
          percentage: currentPercentage
        }));
      });
    }

    if (hasErrorData.length === 0) setIsValidation(false);

    // ? Hide Loading
    if (percentage === currentPercentage) {
      setTimeout(() => {
        setLoading(prev => ({
          ...prev,
          show: false,
          percentage: 0
        }));
      }, 500);
    }
  };

  // * Save Import
  const submitData = () => {
    setLoading(prev => ({
      ...prev,
      show: true,
      percentage: 0
    }));

    const tempData = [...donorRows];
    const percentage = (tempData.length * 100) / tempData.length;

    let currentPercentage = 0;
    const successProcessData = [];

    for (const item of donorRows) {
      dispatch(actions.createImportDonatur(item)).then(response => {
        // ? Loading State
        successProcessData.push(response);
        currentPercentage = Math.floor(
          (successProcessData.length * 100) / tempData.length
        );

        setLoading(prev => ({
          ...prev,
          percentage: currentPercentage
        }));
        // ? Hide Loading
        if (percentage === currentPercentage) {
          setLoading(prev => ({
            ...prev,
            show: false,
            percentage: 0
          }));
          toast.success("Created Successfully", toastOption);
          backToList();
        }
      });
    }
  };

  const createTemplate = async () => {
    const workbook = new ExcelJS.Workbook();
    workbook.creator = "DONORIAN";
    workbook.created = new Date();
    workbook.addWorksheet("import_donatur");

    const worksheet = workbook.getWorksheet("import_donatur");
    worksheet.columns = [
      { header: "No", key: "no", width: 5 },
      {
        header: "Tipe Donatur *",
        width: 15,
        key: "type"
      },
      {
        header: "Nama *",
        width: 20,
        key: "name"
      },
      {
        header: "Sapaan",
        width: 20,
        key: "greeting"
      },
      { header: "HP", width: 20, key: "hp" },
      {
        header: "Email",
        width: 20,
        key: "email"
      },
      {
        header: "Alamat",
        width: 50,
        key: "address"
      },
      {
        header: "Kecamatan",
        width: 15,
        key: "district"
      },
      {
        header: "Kota",
        width: 15,
        key: "city"
      },
      {
        header: "Provinsi",
        width: 20,
        key: "province"
      },
      {
        header: "Kodepos",
        width: 10,
        key: "postal_code"
      },
      {
        header: "NIK / Nomor KTP / Nomor Perusahaan",
        width: 30,
        key: "nik"
      },
      {
        header: "NPWP",
        width: 30,
        key: "npwp"
      },
      {
        header: "Status Hidup",
        width: 10,
        key: "is_alive"
      },
      {
        header: "Status Keaktifan",
        width: 10,
        key: "is_active"
      },
      {
        header: "Kode Rekening",
        width: 30,
        key: "kode_rekening"
      }
    ];

    // * Tipe Donatur
    worksheet.dataValidations.add("B2:B101", {
      type: "list",
      allowBlank: false,
      operator: "equal",
      formulae: ['"INDIVIDU,LEMBAGA,KOMUNITAS"'],
      showErrorMessage: true,
      errorStyle: "error",
      error: "Harap Input Sesuai List Tipe Donatur"
    });

    // * Nama Donatur
    worksheet.dataValidations.add("C2:C101", {
      type: "textLength",
      allowBlank: false,
      operator: "greaterThan",
      formulae: [0],
      showErrorMessage: true,
      errorStyle: "error",
      error: "Harap Input Nama Donatur"
    });

    // * Sapaan
    worksheet.dataValidations.add("D2:D101", {
      type: "list",
      allowBlank: true,
      // operator: "equal",
      formulae: ['"Bapak,Ibu,Mr.,Mrs.,Haji,Hajjah"']
      // showErrorMessage: true,
      // errorStyle: "error",
      // error: "Harap Input Sesuai List Sapaan",
    });

    // * Status Hidup
    worksheet.dataValidations.add("N2:N101", {
      type: "list",
      allowBlank: true,
      operator: "equal",
      formulae: ['"Hidup,Meninggal"'],
      showErrorMessage: true,
      errorStyle: "error",
      error: "Harap Input Sesuai List Status Hidup"
    });

    // * Status Aktif
    worksheet.dataValidations.add("O2:O101", {
      type: "list",
      allowBlank: true,
      operator: "equal",
      formulae: ['"Aktif,Non-Aktif"'],
      showErrorMessage: true,
      errorStyle: "error",
      error: "Harap Input Sesuai List Status Aktif"
    });

    worksheet.columns.forEach((column, i) => {
      var maxLength = 0;
      column["eachCell"]({ includeEmpty: true }, cell => {
        var columnLength = cell.value ? cell.value.toString().length : 10;
        if (columnLength > maxLength) {
          maxLength = columnLength;
        }
      });
      column.width = maxLength < 10 ? 10 : maxLength;
    });

    workbook.xlsx.writeBuffer().then(buffer => {
      saveAs(
        new Blob([buffer], {
          type: "application/octet-stream"
        }),
        `template_import_donatur.xlsx`
      );
    });
  };

  // * Modal
  const hideEditDonor = () => {
    setOpenEditDonor(prev => ({
      ...prev,
      show: false,
      initValues: {}
    }));
  };

  // * Handle update data error
  const handleSaveEditDonor = values => {
    const currentItem = errorRows.find(
      errItem => errItem.data.uuid === values.uuid
    );
    setDonorRows(prev => {
      const temp = [...prev];
      temp.push(values);
      return temp;
    });
    setErrorRows(prev => {
      const temp = [...prev];
      const newArray = temp.filter(
        item => item.data.uuid !== currentItem?.data.uuid
      );
      return newArray;
    });
    hideEditDonor();
  };

  const deleteRow = row => {
    setErrorRows(prev => {
      const temp = [...prev];
      const newArray = temp.filter(donor => donor.data.uuid !== row.data.uuid);

      return newArray;
    });
  };

  return (
    <>
      <Loading {...loading} />
      {/* <LoadingAnimation open={actionsLoading} /> */}
      <ModalEditDonor
        {...openEditDonor}
        onHide={hideEditDonor}
        onSubmit={handleSaveEditDonor}
      />
      <Card>
        <CardHeader title="Import Donatur">
          <CardHeaderToolbar>
            <button className="btn btn-primary" onClick={createTemplate}>
              Download Template
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <ImportDonaturForm
            actionsLoading={actionsLoading}
            importMutationImportDonatur={{}}
            setSpreadSheet={setSpreadSheet}
          />
        </CardBody>
      </Card>
      {errorRows.length !== 0 && (
        <Card>
          <CardHeader title="Data tidak valid" />
          <CardBody>
            <DonorInvalidTable
              errorRows={errorRows}
              setOpenEditDonor={setOpenEditDonor}
              deleteRow={deleteRow}
            />
          </CardBody>
        </Card>
      )}
      <Card>
        <CardHeader title="Data Valid" />
        <CardBody>
          <ImportDonaturTable dataTable={donorRows} />
        </CardBody>
        <CardFooter>
          {isValidation ? (
            <>
              {errorRows.length === 0 && (
                <ActionButton
                  variant="warning"
                  className="mx-1 float-right"
                  onClick={() => validateData(donorRows)}
                  text="Validasi"
                />
              )}
            </>
          ) : (
            <>
              <ActionButton
                className="mx-1 float-right"
                onClick={submitData}
                text="Simpan"
              />
            </>
          )}
        </CardFooter>
      </Card>
    </>
  );
};
